<template>
    <div class="bodyApp" style="background:#0D033F">
        <div class="f_img">
            <img src="@/assets/haoka/1.jpg" alt="" style="margin-bottom:17px;margin-top:13px;width:100%;">
        </div>
        <div class="from_data">
            <div class="f_data" id="formData">
                <div class="f_title">限时免费领取入口</div>
                <van-swipe class="my-swipe" :autoplay="5000" vertical :loop="true" :height="36" :show-indicators="false">
                    <van-swipe-item>曾** 已领取 1分钟前 <span>已有18379人申请</span></van-swipe-item>
                    <van-swipe-item>李** 正在领取 1分钟前    <span>已有18379人申请</span></van-swipe-item>
                    <van-swipe-item>张** 已领取 1分钟前    <span>已有18379人申请</span></van-swipe-item>
                    <van-swipe-item>赵** 已领取 1分钟前    <span>已有18379人申请</span></van-swipe-item>
                    <van-swipe-item>钱** 正在领取 1分钟前    <span>已有18379人申请</span></van-swipe-item>
                    <van-swipe-item>孙** 已领取 1分钟前      <span>已有18379人申请</span></van-swipe-item>
                </van-swipe>
                <van-cell-group>
                    <van-field  v-model="dataFrom.takeNickname"  clearable  label="姓名" placeholder="请输入姓名（已加密）"  />
                    <van-field v-model="dataFrom.takePhone"  maxlength="11" clearable label="联系号码" placeholder="请输入联系号码（已加密）" />
                    <van-field v-model="dataFrom.pcaAddress" clearable label="省市区" placeholder="请选择省市区" readonly @focus="showAddressVisible()"/>
                    <van-field v-model="dataFrom.takeAddress" clearable label="详细地址" placeholder="请输入详细地址" />
                    <van-field v-if="dataFrom.takeAddress.length>2" v-model="dataFrom.idCard"  maxlength="28" clearable label="身份证号" placeholder="请输入入网身份证号（已加密）" />
                </van-cell-group> 
                <van-popup v-model="dataFrom.addressVisible" position="bottom">
            <van-area
                :area-list="areaList"
                :columns-placeholder="['请选择', '请选择', '请选择']"
                @cancel="cancelSelectAddress()"
                @confirm="selectAddress"
            />
        </van-popup>
                <div class="checkbox-info">
                    <van-row>
                        <van-col :span="2" style="text-align:center;">
                            <van-checkbox v-model="checked"></van-checkbox> 
                        </van-col>
                        <van-col :span="22" style="font-size:14px;">
                            <span >我已阅读并同意</span>
                            <span style="color:#FF5700;line-height:26px;">《用户入网协议》</span>
                            <span>和</span>
                            <span style="color:#FF5700;cursor: pointer;">《个人信息收集、使用规则的公告》</span>
                        </van-col>
                    </van-row>
                </div>
                 <p style="text-align: center; color:red">客服咨询微信：LCR-627</p>
                <van-button round type="info" class="btnButton" @click="sunmbitFn()">0元申请 包邮到家</van-button>
            </div>
        </div>
        <div class="f-swige">
            <div class="f_new">热门评论</div>
            <van-swipe class="my-swipe"  vertical :autoplay="5000" :loop="true" :height="70" :show-indicators="false">
                <van-swipe-item><div class="jusaf">
                    <van-row>
                        <van-col span="4">
                            <img src="@/assets/stage/icon17.png" alt=""/> 
                        </van-col>
                        <van-col span="20">
                            <div style="color:#000;height:20px;line-height: 20px;">
                                <van-row>
                                    <van-col span="12"> 盈**牛 </van-col>
                                    <van-col span="12" style="text-align:right;color:#999;">234</van-col>
                                </van-row>
                            </div>
                            <div style="color: rgb(153, 153, 153);line-height: 20px;">网速杠杠的，费用美美的</div>
                        </van-col>
                    </van-row>
                </div></van-swipe-item>
                <van-swipe-item><div class="jusaf">
                        <van-row>
                        <van-col span="4">
                            <img src="@/assets/stage/icon17.png" alt=""/> 
                        </van-col>
                        <van-col span="20">
                            <div style="color:#000;height:20px;line-height: 20px;">
                                <van-row>
                                    <van-col span="12">罗**</van-col>
                                    <van-col span="12" style="text-align:right;color:#999;">234</van-col>
                                </van-row>
                            </div>
                            <div style="color: rgb(153, 153, 153);line-height: 20px;">还便宜，网速还很快</div>
                        </van-col>
                    </van-row>
                </div></van-swipe-item>
                <van-swipe-item><div class="jusaf">
                        <van-row>
                        <van-col span="4">
                            <img src="@/assets/stage/icon17.png" alt=""/> 
                        </van-col>
                        <van-col span="20">
                            <div style="color:#000;height:20px;line-height: 20px;">
                                <van-row>
                                    <van-col span="12">离**歌</van-col>
                                    <van-col span="12" style="text-align:right;color:#999;">234</van-col>
                                </van-row>
                            </div>
                            <div style="color: rgb(153, 153, 153);line-height: 20px;">不错......很划算</div>
                        </van-col>
                    </van-row>
                </div></van-swipe-item>
                <van-swipe-item><div class="jusaf">
                        <van-row>
                        <van-col span="4">
                            <img src="@/assets/stage/icon17.png" alt=""/> 
                        </van-col>
                        <van-col span="20">
                            <div style="color:#000;height:20px;line-height: 20px;">
                                <van-row>
                                    <van-col span="12">辣**果</van-col>
                                    <van-col span="12" style="text-align:right;color:#999;">234</van-col>
                                </van-row>
                            </div>
                            <div style="color: rgb(153, 153, 153);line-height: 20px;">好实惠的手机套餐，经济适用。</div>
                        </van-col>
                    </van-row>
                </div></van-swipe-item>
                <van-swipe-item><div class="jusaf">
                        <van-row>
                        <van-col span="4">
                            <img src="@/assets/stage/icon17.png" alt=""/> 
                        </van-col>
                        <van-col span="20">
                            <div style="color:#000;height:20px;line-height: 20px;">
                                <van-row>
                                    <van-col span="12">王**森</van-col>
                                    <van-col span="12" style="text-align:right;color:#999;">234</van-col>
                                </van-row>
                            </div>
                            <div style="color: rgb(153, 153, 153);line-height: 20px;">手机卡到的很快,激活顺利,套餐价格优惠,满意.</div>
                        </van-col>
                    </van-row>
                </div></van-swipe-item>
                <van-swipe-item><div class="jusaf">
                        <van-row>
                        <van-col span="4">
                            <img src="@/assets/stage/icon17.png" alt=""/> 
                        </van-col>
                        <van-col span="20">
                            <div style="color:#000;height:20px;line-height: 20px;">
                                <van-row>
                                    <van-col span="12">严**</van-col>
                                    <van-col span="12" style="text-align:right;color:#999;">234</van-col>
                                </van-row>
                            </div>
                            <div style="color: rgb(153, 153, 153);line-height: 20px;">很好，到达时间快，业务员上门服务，便宜优惠</div>
                        </van-col>
                    </van-row>
                </div></van-swipe-item>
                <van-swipe-item><div class="jusaf">
                        <van-row>
                        <van-col span="4">
                            <img src="@/assets/stage/icon17.png" alt=""/> 
                        </van-col>
                        <van-col span="20">
                            <div style="color:#000;height:20px;line-height: 20px;">
                                <van-row>
                                    <van-col span="12">莹**子</van-col>
                                    <van-col span="12" style="text-align:right;color:#999;">234</van-col>
                                </van-row>
                            </div>
                            <div style="color: rgb(153, 153, 153);line-height: 20px;">好实惠的手机套餐，经济适用。</div>
                        </van-col>
                    </van-row>
                </div></van-swipe-item>
                <van-swipe-item><div class="jusaf">
                        <van-row>
                        <van-col span="4">
                            <img src="@/assets/stage/icon17.png" alt=""/> 
                        </van-col>
                        <van-col span="20">
                            <div style="color:#000;height:20px;line-height: 20px;">
                                <van-row>
                                    <van-col span="12">毛**九</van-col>
                                    <van-col span="12" style="text-align:right;color:#999;">234</van-col>
                                </van-row>
                            </div>
                            <div style="color: rgb(153, 153, 153);line-height: 20px;">网速杠杠的，费用美美的</div>
                        </van-col>
                    </van-row>
                </div></van-swipe-item>
            </van-swipe>
        </div>
        
       <div class="f_img">
            <img src="@/assets/haoka/2.jpg" alt="" style="margin-bottom:38px;width:100%;">
        </div>
          <div class="f_img">
            <img src="@/assets/haoka/3.jpg" alt="" style="margin-bottom:38px;width:100%;">
        </div>
        
       
       
        <div class="f-tbottm" @click="aaaa" >资费详情介绍</div>
        <div class="chColor" v-if="isShow" @click="changeTab">0元申请 包邮到家</div>
    </div>
</template>
  <!-- Bytedance Tracking -->
    <script>
      (function(r,d,s){r._tt_config=true;var _baq=(r._baq=r._baq||[]);_baq.methods=["track","off","on"];
      _baq.factory=function(method){return function(){var args=Array.prototype.slice.call(arguments);
      args.unshift(method);_baq.push(args);return _baq}};for(var i=0;i<_baq.methods.length;i++){
      var key=_baq.methods[i];_baq[key]=_baq.factory(key)}_baq.load=function(){
      var js,fjs=d.getElementsByTagName(s)[0];js=d.createElement(s);
      js.src="https://analytics.oceanengine.com/api/v2/js/sdk";fjs.parentNode.insertBefore(js,fjs)};
      _baq.load();if(_baq.invoked){return}_baq.invoked=true;_baq.track("pageview")})(window,document,"script");
    </script>
  <!-- End Bytedance Tracking -->
<script>
import areaListData from "@/utils/Area.js";
import { wxRequest } from '@/api/user'
import { Toast,Dialog } from 'vant';
export default {
    data(){
        return{
                   isFirst: 0,
             smsCode: '',
             smsFlag:false,
            btnTxt: '获取验证码',
            time: 3 * 60 * 60 * 1000,
            dataFrom:{
                oldIccid:'页面82',
                takeNickname:'' ,
                provinceCode:'',
                cityCode:'',
                postDistrictCode:'',
                addressVisible:false,
                takePhone:'',
                phoneNum:'',
                takeAddress:'',
                changeCmccSim:'1',
                pcaAddress:'',
                idCard:''
            },
            checked:false,
            isShow:false,
            areaList:areaListData
        }
    },
     mounted() {
       // 滚动条的获取
       window.addEventListener('scroll', this.handleScrollx, true)
    },
    destroyed() { //离开这个界面之后，删除滚动事件，不然容易除bug
        window.removeEventListener('scroll', this.handleScrollx)
    },
    methods:{
          getSmsCode(){
              const rulut = this.$getRsaCode(this.dataFrom.takePhone) //加密
            var data = {
                userPhone: rulut
            }
            wxRequest("bindPhone/sms/code/auth", data, "post").then(res => {
                if(res.data.code == 200){
                    var n = 60;
                    this.btnTxt = '重新发送' + n +'s';
                    let timer = window.setInterval(() => {   
                        n--;                     
                        this.btnTxt = '重新发送' + n +'s';
                        if(n < 1){
                            window.clearInterval(timer);
                            this.btnTxt = '获取验证码';
                        }
                    },1000)
                   Toast.success("发送成功");
                }else{
                    Dialog.alert({title: "提示", message:res.data.message});
                }
            })
        },
        handleScrollx() {
            if(window.pageYOffset >= 600){
                this.isShow = true
            }else{
                this.isShow = false
            }
        },
        changeTab(){
            document.getElementById('formData').scrollIntoView({
                block: 'center',
                behavior: 'smooth' // 代表平滑滚动
            });
        },
        cancelSelectAddress() {
            this.dataFrom.pcaAddress = "";
            this.dataFrom.addressVisible = false;
        },
        showAddressVisible() {
            this.dataFrom.addressVisible = true;
        },
        selectAddress(values) {
            if (!values[0].code || values[0].code.length < 1) {
                Toast.fail("请选择地区");
                return;
            }

            if (!values[1].code || values[1].code.length < 1) {
                Toast.fail("请选择地区");
                return;
            }

            if (!values[2].code || values[2].code.length < 1) {
                Toast.fail("请选择地区");
                return;
            }

            if (
                values[0].code == "110000" ||
                values[0].code == "120000" ||
                values[0].code == "310000" ||
                values[0].code == "500000"
            ) {
                this.dataFrom.pcaAddress = values[0].name +'-'+ values[2].name;
            } else {
                this.dataFrom.pcaAddress = values[0].name +'-'+ values[1].name +'-'+ values[2].name;
            }
            this.dataFrom.addressVisible = false;
        },
        // 提交数据
        sunmbitFn(){
                if(!this.checked){
            Toast.fail('请勾选个人信息收集证明协议');
            return
            }
             this.dataFrom.smsCode=this.smsCode;
             wxRequest('/applyChangeSim/apply/sim/add/haoka/ex', this.dataFrom, 'post').then(res => {
                    if(res.data.code == 200){
                           _baq.track("form", { assets_id: "1741391257951252", product_name: '鞋子', product_price: 10 })
                        Toast.fail('提交成功，预计24时小时内发货，请耐心等待！');
                    }else {
                        Toast.fail(res.data.message);
                    }
                })
        },
        aaaa(){
            Dialog.confirm({
            title: '资费详情',
            width:'90%',
            showCancelButton:false,
            messageAlign:'left',
            confirmButtonColor:'#ee0a24',
            message: `尊敬的客户：\n套餐详情
    ①原套餐59元20G通用+ 30G定向，添加1元即得50G通用流量和31元优惠包，优惠包为官方优惠，12个月有效期，到期续约（20年有效）。
    ②激活必须参与存100元得130元活动(30元为体验金)，本金100直接到账
    激活参与预存后可享
    ①首月免月租,次月起29元/月包70G通用+ 30G定向（20年）
    ②首月流量按天折算，超出套餐流量5元/G
    免流范围：
    爱奇艺、腾讯视频、优酷视频、抖音短视频、西瓜视频、快手、网易云音乐、百度系、头条系、网易系等
    更多免流范围查询：
    请关注“星卡助⼿”微信公众号，回复关键词“免流”或“免流范围”。
    注意事项：
    1、本卡只可使用流量，无通话功能
    2、可收发短信(短信0.1元/条)
    3、开卡年龄:16-55周岁
    4、本卡不可办理副卡
    5、收货后，请在20天内激活，过期订单将关闭，无法激活。
    禁发地：
    茂名、儋州、来宾、防城港、崇左、上思、南宁、龙岩、莆田、抚州、威宁、彝族回族苗族自治县、秦皇岛、无锡、杭州、河南全省、西藏、新疆、云南全省、北京
            `
            }).then(() => {
                // on confirm
            }).catch(() => {
                // on cancel
            });
        },
    }
}
</script>
<style lang="less" scoped>

    .f_img{
        text-align: center;
    }
    .chColor{
        width: 90%;
        height: 44px;
        color: #fff;
        text-align: center;
        line-height: 44px;
        border-radius: 24.5px;
        font-size: 23px;
        position: fixed;
        bottom: 20px;
        z-index: 100;
        left: 0;
        margin-left: 5%;
        background: -webkit-linear-gradient(to right,#FEAC37,#FD7324); /* Safari 5.1-6.0 */
        background: -o-linear-gradient(to right,#FEAC37,#FD7324); /* Opera 11.1-12.0 */
        background: -moz-linear-gradient(to right,#FEAC37,#FD7324); /* Firefox 3.6-15 */
        background: linear-gradient(to right,#FEAC37,#FD7324); /* 标准语法 */
        border:1px solid #FD7324;
        border-image: -webkit-linear-gradient(to right,#FEAC37,#FD7324); /* Safari 5.1-6.0 */
        border-image: -o-linear-gradient(to right,#FEAC37,#FD7324); /* Opera 11.1-12.0 */
        border-image: -moz-linear-gradient(to right,#FEAC37,#FD7324); /* Firefox 3.6-15 */
        border-image: linear-gradient(to right,#FEAC37,#FD7324); /* 标准语法 */
    }
    .chColor{
        -webkit-animation: free_download1 1s linear alternate infinite;
        animation: free_download1 1s linear alternate infinite;
    }
    @-webkit-keyframes free_download1{
        0%{-webkit-transform:scale(0.9);}
        100%{-webkit-transform:scale(1);}
    }
    @keyframes free_download1{
        0%{transform:scale(0.9);}
        100%{transform:scale(1);}
    }
    .from_data{
        margin:0 14px;
        background: #fff;
        padding:9px;
        border-radius: 10px;
        .f_data{
            border-radius: 10px;
            border:1px dashed #FD7C27;
            .f_title{
                height:42px;
                line-height:42px;
                width:208px;
                background: url(../../../assets/title.png) no-repeat center;
                background-size:100% 100%;
                font-size:20px;
                color:#fff;
                text-align:center;
                margin: -21px auto 0 auto;
            }
            .my-swipe{
                height: 35px; 
                line-height:35px;
                background: #787B81;
                border-radius:6px;
                width:82%;
                margin:13px auto;
                color: #fff;
                padding:0 12px;
                span{
                    display: inline-block;
                    padding-left:16px;
                }
            }
            .checkbox-info{
                width: 85%;
                margin: 10px auto;
                font-size:12px;
                .van-checkbox{
                    display: inline-block;
                    margin-top: 4px;
                }
            }
            .btnButton{
                width:93%;
                margin: 10px auto;
                display: block;
                background: -webkit-linear-gradient(to right,#FEAC37,#FD7324); /* Safari 5.1-6.0 */
                background: -o-linear-gradient(to right,#FEAC37,#FD7324); /* Opera 11.1-12.0 */
                background: -moz-linear-gradient(to right,#FEAC37,#FD7324); /* Firefox 3.6-15 */
                background: linear-gradient(to right,#FEAC37,#FD7324); /* 标准语法 */
                border:1px solid #FD7324;
                border-image: -webkit-linear-gradient(to right,#FEAC37,#FD7324); /* Safari 5.1-6.0 */
                border-image: -o-linear-gradient(to right,#FEAC37,#FD7324); /* Opera 11.1-12.0 */
                border-image: -moz-linear-gradient(to right,#FEAC37,#FD7324); /* Firefox 3.6-15 */
                border-image: linear-gradient(to right,#FEAC37,#FD7324); /* 标准语法 */
                cursor: pointer;
                font-size:18px;
            }
            .btnButton{
                -webkit-animation: free_download 1s linear alternate infinite;
                animation: free_download 1s linear alternate infinite;
            }
            @-webkit-keyframes free_download{
                0%{-webkit-transform:scale(0.9);}
                100%{-webkit-transform:scale(1);}
            }
            @keyframes free_download{
                0%{transform:scale(0.9);}
                100%{transform:scale(1);}
            }
        }
    }
    .f-swige{
        margin:10px 14px;
        background: #fff;
        padding:9px;
        border-radius: 10px;
        height:250px;
        overflow: hidden;
        .f_new{
            font-size: 18px;
            padding:14px 0 15px 12px;
            font-weight: 600;
        }
        .jusaf{
            img{
                width:52px;
                height:52px;
            }
        }
    }
    .f-tbottm{
        width:100%;
        margin-top: 17px;
        padding-bottom: 26px;
        text-align:center;
        font-size:16px;
        cursor: pointer;
        color:#fff;
    }
</style>